export interface IFormData {
    currentPageId: number;
    pageData: Object;
    nextPageId: number;
};



// WEBPACK FOOTER //
// ./src/app/stage/types/form-data.ts